import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-screen flex items-center justify-center bg-[#050505] text-zinc-400 font-mono-accent text-sm tracking-widest"
      >
        LOADING…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
